<template>

    <div class="Form__group is--indicatif" :class="{ 'is--error' : errorIdentifier }">
      <label :for="name + '_number'">{{ label }} <abbr v-show="required" title="Requis">*</abbr></label>
      <Select
          label="Indicatif"
          :name="name + '_identifier'"
          :id="name + '_identifier'"
          @input="$emit('update:identifier', $event.target.value)"
          @change="onChange"
          v-model="identifierValue"
          :options="mappedIdentifiers"
          :required="required"
          :error="!!errorIdentifier"
      />
    </div>

    <Input
        :placeholder="label"
        type="text"
        @input="$emit('update:phone', $event.target.value)"
        @change="onChange"
        :name="name + '_number'"
        :id="name + '_number'"
        :required="required"
        v-model="phoneValue"
        :error="!!errorPhone"
    />

    <div class="error__container" v-if="errorIdentifier || errorPhone">
      <span>{{ errorIdentifier }}</span>
      <span>{{ errorPhone }}</span>
    </div>

</template>


<script>
import Input from "@components/form/Input";
import Select from "@components/form/Select";
import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";

export default {
  props: ['errorPhone', 'errorIdentifier', 'label', 'identifiers', 'identifier', 'phone', 'required', 'name'],
  components: { Select, Input},

  setup(props, {emit}){
    const identifiers = props.identifiers ? props.identifiers : Inertia.page.props.forms.identifiers;

    const identifierValue = ref(props.identifier)
    const phoneValue = ref(props.phone)

    const onChange = (value) => {
      emit('update:identifier', identifierValue.value)
      emit('update:phone', phoneValue.value)
    };

    return {
      onChange,
      identifierValue,
      phoneValue,
      mappedIdentifiers: Object.keys(identifiers).map((value) => ({
        value: identifiers[value].code, label: `${identifiers[value].code} (${identifiers[value].abreviation})`
      }))
    }
  }
}
</script>
